<template>
  <div :class="$options.name">
    <v-card>
      <tags-table
        :items="list"
        :current-page="pagination.currentPage"
        :last-page="pagination.lastPage"
        :loading="loading"
        @onDoReload="doReload"
      />
    </v-card>
  </div>
</template>

<script>

import TagsTable from '@/views/tags/components/TagsTable.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'references-icons-list-view',

  async asyncData({ store }) {
    const actions = [
      store.dispatch('tags/getList'),
    ];

    return Promise.all(actions);
  },

  components: { TagsTable },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState('tags', ['list', 'pagination']),
  },

  methods: {
    ...mapActions('tags', ['getNextPage']),

    async doReload(params) {
      this.loading = true;

      await this.getNextPage({
        perPage: this.pagination.perPage,
        ...params,
      });

      this.loading = false;
    },
  },
};

</script>
